module.exports = __webpack_public_path__ + "static/media/baseline-notifications_none-24px.3d195e25.svg";